import _ from 'lodash';
import { apiFetch } from '../utility';

const apiBase = 'invoiceCreditMemo';

export const createForStationInvoice = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.createForStationInvoice`,
			params,
			dispatch,
			callback,
		});
	};
};

export const send = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.send`,
			params,
			dispatch,
			callback,
		});
	};
};

export const invalidate = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const search = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback,
		});
	};
};
